import { FormControl, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { EnvFeatureFlagContext } from "../../../../../contexts/EnvFeaturesContext";
import { AssetClass } from "../../../../../utils/constants";
import AssetBusinessValue from "./AssetBusinessValue";
import AssetDescription from "./AssetDescription";
import AssetNameInput from "./AssetNameInput";
import AssetTypeSelect from "./AssetTypeSelect";

const AssetDetailsStep = ({ setFormData, formData, assetToEdit = null }) => {
  const disabled = assetToEdit?.asset?.cls === AssetClass.SMART;
  const { businessValueMode } = useContext(EnvFeatureFlagContext);
  return (
    <Grid container direction="column" minWidth={"400px"} gap={3}>
      <Typography variant="subtitle2">
        Enter key details about the asset
      </Typography>
      <Grid item>
        <FormControl fullWidth>
          <AssetNameInput
            formData={formData}
            setFormData={setFormData}
            assetToEdit={assetToEdit}
          />
        </FormControl>
      </Grid>

      {/* Type */}
      <Grid item>
        <FormControl fullWidth>
          <AssetTypeSelect
            setFormData={setFormData}
            formData={formData}
            disabled={disabled}
          />
        </FormControl>
      </Grid>
      {/* Business Value */}
      {businessValueMode && (
        <Grid item>
          <FormControl fullWidth>
            <AssetBusinessValue formData={formData} setFormData={setFormData} />
          </FormControl>
        </Grid>
      )}
      {/* Description */}
      <Grid item>
        <FormControl fullWidth>
          <AssetDescription
            formData={formData}
            setFormData={setFormData}
            disabled={disabled}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default AssetDetailsStep;
